import { ApplicationEnvironmentMolecule } from "@/app/env/store"
import { usePrivy } from "@privy-io/react-auth"
import { wrap } from "@reatom/core"
import { useMolecule } from "bunshi/react"
import { useCallback, useEffect, useRef } from "react"

export function useAccountEmailAuth() {
  const { user, authenticated, ready, getAccessToken } = usePrivy()
  const { bffBaseUrl } = useMolecule(ApplicationEnvironmentMolecule)
  const userId = user?.id ?? null
  const currentAccount = useRef(userId)
  currentAccount.current = userId
  useEffect(() => {
    currentAccount.current = userId
    return () => {
      currentAccount.current = null
    }
  }, [userId])
  const guardedAccessToken = useCallback(async () => {
    const token = await wrap(getAccessToken())
    if (currentAccount.current !== userId)
      throw new Error("Your Account changed. Please try again.")
    return token
  }, [getAccessToken, userId])
  return {
    userId,
    authenticated,
    loading: !ready,
    bffBaseUrl,
    email:
      user?.linkedAccounts.find((account) => account.type === "email")
        ?.address ?? null,
    getAccessToken: guardedAccessToken,
  }
}
